export default __webpack_public_path__ + "static/media/dropverse-stack4.webp";